import initStore from './index'
import menu from './modules/menu.js'

export default initStore({
  menu,
})
